import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import "./styles.css";
import "react-form-builder2/dist/app.css";
import "formiojs/dist/formio.full.css";

// Import the AuthProvider
import { AuthProvider } from './context/AuthContext';

// Import components
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import AppHeader from './components/AppHeader';

// Import pages
import Create from "./pages/create";
import Edit from "./pages/edit";
import View from "./pages/view.js";
import Submission from "./pages/submission";
import NoPage from "./pages/NoPage";
import ThankYou from "./pages/thankyou.js";
import List from "./pages/list.js";

// Layout wrapper for protected pages (with header)
const ProtectedLayout = ({ children }) => (
  <>
    <AppHeader />
    <div className="main-content">
      {children}
    </div>
  </>
);

// Layout wrapper for public pages (no header)
const PublicLayout = ({ children }) => (
  <div className="public-content">
    {children}
  </div>
);

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <Switch>
          {/* Public login route */}
          <Route path="/login" component={Login} />
          
          {/* ========== PUBLIC ROUTES (No Login Required, No Header) ========== */}
          
          {/* Public submission route - accessible via URL params like ?fid=123&tcid=456 */}
          <Route path="/submission">
            <PublicLayout>
              <Submission />
            </PublicLayout>
          </Route>
          
          {/* Public thank you page */}
          <Route path="/thankyou">
            <PublicLayout>
              <ThankYou />
            </PublicLayout>
          </Route>
          
          {/* Public view page - accessible via URL params like ?id=123&table=form_data */}
          <Route path="/View">
            <PublicLayout>
              <View />
            </PublicLayout>
          </Route>

          {/* ========== PROTECTED ROUTES (Login Required, With Header) ========== */}
          
          <ProtectedRoute exact path="/">
            <ProtectedLayout>
              <List />
            </ProtectedLayout>
          </ProtectedRoute>
          
          <ProtectedRoute path="/Create">
            <ProtectedLayout>
              <Create />
            </ProtectedLayout>
          </ProtectedRoute>
          
          <ProtectedRoute path="/Edit">
            <ProtectedLayout>
              <Edit />
            </ProtectedLayout>
          </ProtectedRoute>
          
          {/* 404 page - Public (no login needed) */}
          <Route path="*">
            <PublicLayout>
              <NoPage />
            </PublicLayout>
          </Route>
        </Switch>
      </Router>
    </AuthProvider>
  );
}